import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import moment from 'moment';

import DateRangeSelection, { RANGE_TYPES } from "components/dashboard/DateRangeSelection";
import { createAction, formatNumberWithCommas } from "utils";

import "./MessageCredit.scss"

function CreditItem({ title, spent }) {
  return <div className="credit-item-width">
    <label className="section-short-description">{title}</label>
    <div className="credit-item-title-credit-spacing">
      {formatNumberWithCommas(spent || "0.00")}
    </div>
  </div>
}

export const MessageCreditCardContent = ({ realCreditTotalSpent, whatsappCreditTotalSpent, smsCreditTotalSpent, emailCreditTotalSpent }) => {
  const dispatch = useDispatch();

  const [lastUpdateTime, setLastUpdateTime] = useState(moment().format("DD MMM yyyy(ddd), HH:mm a"))

  return (
    <div className="message-credit-card-content">
      <div className="message-credit-card-header">
        <div className="message-credit-card-title">{"Messages Credit"}</div>
        <div>{`Last update time: ${lastUpdateTime}`}</div>
      </div>

      <div className="message-credit-spent-section">
        <div className="message-credit-date-range" >
          <DateRangeSelection
            applyDateRangeEvent={(startDate, endDate) => {
              dispatch(createAction('messageList/getMessageCredit')({
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
                successAction: () => {
                  setLastUpdateTime(moment().format("DD MMM yyyy(ddd), HH:mm a"))
                }
              }))
            }}
            clearDataEvent={() => {

            }}
            defaultDateRange={RANGE_TYPES.CURRENT_MONTH}
            isInCustomListComponent={false}
          />
        </div>
        <div >
          <CreditItem title="Total messages sent" spent={realCreditTotalSpent} />
          <div className="credit-item-detail-content">
            <CreditItem title="Total message sent in Whatsapp" spent={whatsappCreditTotalSpent} />
            <CreditItem title="Total message sent in SMS" spent={smsCreditTotalSpent} />
            <CreditItem title="Total message sent in Email" spent={emailCreditTotalSpent} />
          </div>
        </div>
      </div>
    </div>
  )
}

const MessageCredit = ({
  realCreditTotalSpent,
  whatsappCreditTotalSpent,
  smsCreditTotalSpent,
  emailCreditTotalSpent,
}) => {

  return (
    <div className="message-credit-card">
      <MessageCreditCardContent
        realCreditTotalSpent={realCreditTotalSpent}
        whatsappCreditTotalSpent={whatsappCreditTotalSpent}
        smsCreditTotalSpent={smsCreditTotalSpent}
        emailCreditTotalSpent={emailCreditTotalSpent}
      />
    </div>
  )
}

const mapPropsToState = (state) => ({
  realCreditTotalSpent: state.messageList.realCreditTotalSpent,
  whatsappCreditTotalSpent: state.messageList.whatsappCreditTotalSpent,
  smsCreditTotalSpent: state.messageList.smsCreditTotalSpent,
  emailCreditTotalSpent: state.messageList.emailCreditTotalSpent,
});

export default connect(mapPropsToState)(MessageCredit);